import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		// 定义全局状态
		userInfo: localStorage.getItem('userInfo') || null,
		token: localStorage.getItem('token') || '',
		
		swiper: null,
		sysInfo: null
	},
	mutations: {
		// 同步修改状态
		SET_USER_INFO(state, data) {
			state.userInfo = data
		},
		SET_TOKEN(state, token) {
			state.token = token
		},
		
		SET_SWIPER(state, data) {
			state.swiper = data
		},
		SET_SYSINFO(state, data) {
			state.sysInfo = data
		}
	},
	actions: {
		setUserInfo({ commit }, data) {
			commit('SET_USER_INFO', data)
			localStorage.setItem('userInfo', data)
		},
		setToken({ commit }, data) {
			commit('SET_TOKEN', data)
			localStorage.setItem('token', data)
		},
		logout({ commit }) {
		    commit('SET_USER_INFO', null)
		    commit('SET_TOKEN', '')
			localStorage.removeItem('userInfo')
			localStorage.removeItem('token')
		},
		async getUser({ commit }) {
			await this._vm.$http.get('/api/webs/account/getMy')
			    .then(response => {
			        let res = response.data
					commit('SET_USER_INFO', res)
					localStorage.setItem('userInfo', res)
			    })
			    .catch(error => {
			        console.error(error)
			    })
		},
		
		setSwiper({ commit }, data) {
			commit('SET_SWIPER', data)
		},
		setSysInfo({ commit }, data) {
			commit('SET_SYSINFO', data)
		}
	},
	getters: {
		token: state => state.token
	}
})